<template>
    <div class="FamilyClientDisplayAndEdit">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.Client.Person.AKA ? props.rowData.Client.Person.FirstName  + ' &quot;' + props.rowData.Client.Person.AKA + '&quot; ' + props.rowData.Client.Person.LastName  : props.rowData.Client.Person.FullName"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddContact()" class="pointer olive-green-text" />
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-contact" :title="ModalContactTitle" hide-footer :modal-class="IncludeCharting ? 'full-screen-modal' : ''">
            <b-container v-if="EditMode == false && TargetContact.Client">
                <b-row>
                    
                    <b-col>
                        <h3>Name</h3>
                        <p><span class="bold">First Name: </span>{{ TargetContact.Client.Person.FirstName }}</p>
                        <p v-if="TargetContact.Client.Person.AKA"><span class="bold">AKA: </span>{{ TargetContact.Client.Person.AKA }}</p>
                        <p v-if="TargetContact.Client.Person.MiddleName"><span class="bold">Middle Name: </span>{{ TargetContact.Client.Person.MiddleName }}</p>
                        <p><span class="bold">Last Name: </span>{{ TargetContact.Client.Person.LastName }}</p>
                        <p v-if="TargetContact.Client.Person.Suffix"><span class="bold">Suffix: </span>{{ TargetContact.Client.Person.Suffix }}</p>
                    </b-col>
                    <b-col v-if="!HidePersonalInfo">
                        <h3>Personal Info</h3>
                        <p v-if="TargetContact.Client.Person.DOB"><span class="bold">DOB: </span>{{ formatDate(TargetContact.Client.Person.DOB,'MM/DD/YY') }}</p>
                        <p v-if="TargetContact.Client.Person.DOB"><span class="bold">Age: </span>{{ TargetContact.Client.Person.AgeString }}</p>
                        <p v-if="TargetContact.Client.Person.SSN"><span class="bold">SSN: </span>{{ TargetContact.Client.Person.FormattedSSN }}</p>
                        <h3>Demographics</h3>
                        <p v-if="TargetContact.Client.Person.Sex"><span class="bold">Sex: </span>{{ TargetContact.Client.Person.Sex.Name }}</p>
                        <p v-if="TargetContact.Client.Person.Race"><span class="bold">Race: </span>{{ TargetContact.Client.Person.Race.Name }}</p>
                        <p v-if="TargetContact.Client.Person.Ethnicity"><span class="bold">Ethnicity: </span>{{ TargetContact.Client.Person.Ethnicity.Name }}</p>
                        <p><span class="bold">Language: </span>{{ TargetContact.Client.Person.Language }}</p>
                        <p><span class="bold">Is Disabled: </span>{{ TargetContact.Client.Person.IsDisabled }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwFamilyTracking">
                    <b-col>
                        <h3>Background/Clearances</h3>
                        <p><span class="bold">Background Check (16): </span>{{ TargetContact.Client.Person.BC16Obtained != null ? TargetContact.Client.Person.BC16Obtained == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">Background Check (18): </span>{{ TargetContact.Client.Person.BC18Obtained != null ? TargetContact.Client.Person.BC18Obtained == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">Fingerprints Obtained: </span>{{ TargetContact.Client.Person.FingerPrintsObtained != null ? TargetContact.Client.Person.FingerPrintsObtained == true ? 'Yes' : 'No' : '' }}</p>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <p><span class="bold">Last Flu Shot: </span>{{ formatDate(TargetContact.Client.Person.FluShotDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last Pertussis: </span>{{ formatDate(TargetContact.Client.Person.PertussisDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last TB Test: </span>{{ formatDate(TargetContact.Client.Person.TBVaccinationDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwBabysitterTracking">
                    <b-col>
                        <h3>Document Dates</h3>
                        <p><span class="bold">DL Expiration: </span>{{ formatDate(TargetContact.Client.Person.DriverLicenseExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">CPR Expiration: </span>{{ formatDate(TargetContact.Client.Person.CPRExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">First Aid Expiration: </span>{{ formatDate(TargetContact.Client.Person.FirstAidExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Car Insurance Expiration: </span>{{ formatDate(TargetContact.Client.Person.CarInsuranceExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Policy Agreement Signed: </span>{{ formatDate(TargetContact.Client.Person.PolicyAgreementSignedDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Fingerprint Notice: </span>{{ formatDate(TargetContact.Client.Person.FingerPrintNoticeDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">BCCU Sent: </span>{{ TargetContact.Client.Person.BCCUSent != null ? TargetContact.Client.Person.BCCUSent == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">BCCU Cleared Date: </span>{{ formatDate(TargetContact.Client.Person.BCCUClearedDate,'MM/DD/YY') }}</p>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <p><span class="bold">Last Flu Shot: </span>{{ formatDate(TargetContact.Client.Person.FluShotDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last Pertussis: </span>{{ formatDate(TargetContact.Client.Person.PertussisDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last TB Test: </span>{{ formatDate(TargetContact.Client.Person.TBVaccinationDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Contact Info</h3>
                        <p v-if="TargetContact.Client.Person.Email"><span class="bold">Email: </span>{{ TargetContact.Client.Person.Email }}</p>
                        <p v-for="(phoneNumber, phoneIndex) in TargetContactPhoneNumbers">
                            <span class="bold">{{ phoneNumber.PhoneType }}: </span>{{ phoneNumber.PhoneNumber }} {{ phoneNumber.Description ? '(' + phoneNumber.Description + ')' : '' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Assignment Details</h3>
                        <p><span class="bold">Contact Type: </span>{{ TargetContact.Client.ClientType }}</p>
                        <p><span class="bold">Relationship to {{ RelationshipLabel }}: </span>{{ TargetContact.Relationship }}</p>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetContact.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetContact.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelContact()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditContact">
                    <PersonEditor :edit-mode="true"
                                  :existing-person="TargetContact.Client ? TargetContact.Client.Person : null"
                                  :DOBRequired="RequireDob"
                                  :global-update="GlobalUpdate"
                                  :inline="true"
                                  end-point="tbd"
                                  :control-buttons="false"
                                  :include-pnw-family-tracking="IncludePnwFamilyTracking"
                                  :include-pnw-babysitter-tracking="IncludePnwBabysitterTracking"
                                  :hide-personal-info="HidePersonalInfo"
                                  :include-language="IncludeLanguage"
                                  :include-is-disabled="IncludeIsDisabled"
                                  ref="contact-add-editor" />
                    <b-row>
                        <b-col>
                            <h3>Assignment Details</h3>
                            <div class="form-group">
                                <label>Relationship to {{ RelationshipLabel }}:</label>
                                <div v-if="Array.isArray(RelationshipOptions)">
                                    <select class="form-control" v-model="TargetContact.Relationship" required>
                                        <option v-for="option in RelationshipOptions" :value="option.value">{{ option.text }}</option>
                                    </select>
                                </div>
                                <div v-else-if="RelationshipOptions">
                                    <input class="form-control" required v-model="TargetContact.Relationship" readonly />
                                </div>
                                <div v-else>
                                    <input class="form-control" required v-model="TargetContact.Relationship" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetContact.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetContact.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelContact()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteContact()" type="button" v-if="TargetContact.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import NewDocument from "../RecordComponents/NewDocument.vue";
    import CaseFile from "../RecordComponents/CaseFile.vue";
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import PersonEditor from './PersonEditor.vue';
    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "DispatchOnSuccess",//string[]
            "GetEndpoint",//string
            "GetPayload",//object
            "AddEditEndpoint",//string
            "AddEditPayload",//object
            "DeleteEndpoint",//string
            "DeletePayload",//object
            "DeleteWarning",//string
            "DisplayAgency",//bool
            "DisplayAge",//bool
            "DisplayRelationship",//bool
            "AgencyInput", //bool
            "ChurchInput", //bool
            "DisplayAgency",//bool
            "DisplayChurch",//bool
            "RequireDob",//bool
            "ContactCategory",//string
            "RelationshipOptions",//array or string or null
            "RelationshipLabel",//string
            "IncludeCharting",//bool
            "SubProgramId",//string
            "ProfessionalDropdownEnabled", //bool
            "ProfessionalDropdownEnabledPayload", //object
            "ProfessionalDropdownEnabledEndpoint", //string
            "IncludePnwFamilyTracking",//bool
            "IncludePnwBabysitterTracking",//bool
            "HidePersonalInfo",//bool
            "IncludeIsDisabled",//bool
            "IncludeLanguage",//bool
        ],
        data: function () {
            return {
                selected: [],
                TargetContact: {},
                ModalContactTitle: "",
                LoadedRecords: [],//Contact Membership Records
                Options: [],
                ContactSchema: {
                    Id: "",
                    StartDate: "",
                    EndDate: "",
                    Relationship: "",
                    ClientID: "",
                    Client: {
                        Id: "",
                        ClientType: "",
                        PersonID: "",
                        Person: {
                            FirstName: "",
                            LastName: "",
                            MiddleName: "",
                            Suffix: "",
                            Prefix: "",
                            AKA: "",
                            DOB: "",
                            SexID: "",
                            RaceID: "",
                            EthnicityID: "",
                            Email: "",
                            PhoneNumbers: [],
                            DriverLicenseExpirationDate: "",
                            CPRExpirationDate: "",
                            FirstAidExpirationDate: "",
                            HIVDate: "",
                            CarInsuranceExpirationDate: "",
                            FluShotDate: "",
                            PertussisDate: "",
                            TBVaccinationDate: "",
                            BC16Obtained: "",
                            BC18Obtained: "",
                            FingerPrintsObtained: "",
                            PolicyAgreementSignedDate: "",
                            FingerPrintNoticeDate: "",
                            BCCUClearedDate: "",
                            BCCUSent: ""
                        }
                    }
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                }
                
            };
        },
        methods: {
            onRowClass (dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetContacts() {
                    this.$MasterAPI.ExecuteRequest("GET", this.GetEndpoint, this.GetPayload, this.GetContactsSuccess, () => { }, false);

            },
            GetContactsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            ShowDetailView(contact) {
                this.TargetContact = JSON.parse(JSON.stringify(contact));
                
                if (this.EditMode) {
                    this.ModalContactTitle = "Editing " + contact.Client.Person.FullName;
                } else {
                    this.ModalContactTitle = "Viewing " + contact.Client.Person.FullName;
                }
                this.$refs["modal-contact"].show();
            },
            ShowAddContact() {
                this.TargetContact = JSON.parse(JSON.stringify(this.ContactSchema));
                this.ModalContactTitle = "Add New " + this.ContactCategory;
                if (!Array.isArray(this.RelationshipOptions) && this.RelationshipOptions) {
                    this.TargetContact.ContactRelationship = this.RelationshipOptions;
                }
                this.$refs["modal-contact"].show();
            },
            AddEditContact(e) {
                e.preventDefault();
                //get person data here
                this.TargetContact.Client.Person = this.$refs["contact-add-editor"].GetUpdatedPerson();
                this.TargetContact.Client.ClientType = this.ContactCategory;
                this.$MasterAPI.ExecuteRequest("POST", this.AddEditEndpoint,{ ...this.TargetContact, ...this.AddEditPayload }, this.AddEditContactSuccess, () => { }, true);

            },
            AddEditContactSuccess(response) {
                this.GetContacts();
                EventBus.$emit('profile-update-needed', this.AddEditPayload.ChartID);
                this.$refs["modal-contact"].hide();
            },
            DeleteContact() {
                this.$MasterAPI.ExecuteRequest("POST", this.DeleteEndpoint, { Id: this.TargetContact.Id }, this.DeleteContactSuccess, () => { }, true);

            },
            DeleteContactSuccess(response) {
                this.GetContacts();
                EventBus.$emit('profile-update-needed', this.AddEditPayload.ChartID);
                this.$refs["modal-contact"].hide();
            },
            CancelContact() {
                this.selected = {};
                this.$refs['modal-contact'].hide();
            },
            CancelDelete() {
                this.$refs['modal-delete'].hide();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            flatPickr,
            Vuetable,
            PersonEditor,
            NewDocument,
            CaseFile,
            vSelect
        },
        computed: {
            TableFields: function () {
                let vm = this;
                let fieldData = [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    }
                ];

                if (vm.DisplayRelationship) {
                    fieldData.push( 
                        {
                            name: "Relationship",
                            title: "RELATIONSHIP"
                        }
                    );
                }
                if (vm.DisplayAge) {
                    fieldData.push( 
                        {
                            name: "Client.Person.AgeString",
                            title: "AGE"
                        }
                    );
                }
                

                fieldData.push(
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                );
                fieldData.push(
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                );
                return fieldData;
            },
            TableData: function () {
                return this.LoadedRecords;
            },
            TargetContactPhoneNumbers: function () {
                let phoneNumbers = [];
                if (this.TargetContact.Client) {
                    this.TargetContact.Client.Person.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            phoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }
                return phoneNumbers;
                
            },
            
        },
        mounted() {
            this.GetContacts();
        },

    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr.current-record {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>